const USER_NOTIFICATIONS = {
    UNCONFIRMED_USER: 'UnconfirmedUserNotification',
    ELIGIBLE_FOR_EDUCATIONAL: 'EligibleForEducationalNotification',
    EDUCATION_EXPIRED: 'EducationExpiredNotification',
};

/**
 * add notification even if one of the same type already exists
 */
const USER_NOTIFICATION_APPEND = 'event.notification.append';

/**
 * show notification if it doesn't already exist
 */
const USER_NOTIFICATION_SHOW = 'event.notification.show';
const USER_NOTIFICATION_HIDE = 'event.notification.hide';

export { USER_NOTIFICATIONS, USER_NOTIFICATION_APPEND, USER_NOTIFICATION_SHOW, USER_NOTIFICATION_HIDE };
